import React, { useEffect, useRef, useState, } from "react";
import "./ProductProtfolio.scss";
import BannerSectionStyle5 from "../Section/BannerSection/BannerSectionStyle5";
// import BannerSectionStyle5 from "../Section/BannerSection/BannerSectionStyle5";
// import Section from "../Section";
// import { pageTitle } from "../../helpers/PageTitle";

// const products = [
//   { imgUrl: "/images/home_1/prouctfirst.png", href: "/products/product-1" },
//   { imgUrl: "/images/home_1/prouctsecond.png", href: "/products/product-2" },
//   { imgUrl: "/images/home_1/prouctthird.png", href: "/products/product-3" },
//   { imgUrl: "/images/home_1/prouctfirst.png", href: "/products/product-4" },
//   { imgUrl: "/images/home_1/prouctsecond.png", href: "/products/product-5" },
//   { imgUrl: "/images/home_1/prouctthird.png", href: "/products/product-6" },
//   { imgUrl: "/images/home_1/prouctfirst.png", href: "/products/product-7" },
//   { imgUrl: "/images/home_1/prouctsecond.png", href: "/products/product-8" },
//   { imgUrl: "/images/home_1/prouctthird.png", href: "/products/product-9" },
// ];



//   const ProductProtfolio = () => {
//     useEffect(() => {
//       const fancyCssUrl = "https://cdn.jsdelivr.net/npm/@fancyapps/ui/dist/fancybox.css";
//       const fancyJsUrl = "https://cdn.jsdelivr.net/npm/@fancyapps/ui/dist/fancybox.umd.js";
  
//       if (!document.querySelector(`link[href="${fancyCssUrl}"]`)) {
//         const link = document.createElement("link");
//         link.rel = "stylesheet";
//         link.href = fancyCssUrl;
//         document.head.appendChild(link);
//       }
  
//       function initFancybox() {
//         try {
//           if (window.Fancybox && window.Fancybox.bind) {
//             window.Fancybox.bind('[data-fancybox="awards"]', {});
//           }
//         } catch (e) {}
//       }
  
//       if (window.Fancybox) {
//         initFancybox();
//       } else if (!document.querySelector(`script[src="${fancyJsUrl}"]`)) {
//         const s = document.createElement("script");
//         s.src = fancyJsUrl;
//         s.async = true;
//         s.onload = initFancybox;
//         document.body.appendChild(s);
//       }
//     }, []);
  

//   return (
//     <>
//       <BannerSectionStyle5
//         bgUrl="/images/about/banner_bg.jpg"
//         imgUrl="/images/about/banner_img.png"
//         title="Welcome to Celbion Healthcare"
//         subTitle="Our Products"
//       />

//       <Section topMd={80} bottomMd={120} bottomLg={90}>
//         <div className="container">
//           <div className="cs_section_title cs_style2">
//             <h2 className="cs_title text-center">Our Products</h2>

//             <p className="cs_sub product-text">
//               Celbion Healthcare is committed to delivering meaningful and
//               effectivepharmaceutical solutions for patients and healthcare
//               professionals. Ourcurrent focus includes the promotion of
//               medicines for epilepsy, stroke care, and pain management. As part
//               of our ongoing growth, we have expanded our product portfolio to
//               include therapies for GERD, antibiotics, and antioxidant
//               formulations.
//             </p>
//           </div>

//           <div className="cs_height_40" />

//           <div className="row">
//             {products.map((item, idx) => (
//               <div className="col-lg-4 col-md-6" key={idx}>
//                 <div className="cs_product_box" style={{ padding: 12 }}>
//                   <div className="cs_product_img">
//                     <a data-fancybox="awards" href={item.imgUrl} data-caption={item.title || ""}>
//                       <img
//                         src={item.imgUrl}
//                         alt={item.title}
//                         style={{ width: "100%" }}
//                       />
//                     </a>
//                   </div>

//                   <h3
//                     className="product-title"
//                     style={{ marginTop: 12, fontSize: 16 }}
//                   >
//                     {item.title}
//                   </h3>
//                 </div>

//                 <div className="cs_height_30" />
//               </div>
//             ))}
//           </div>
//         </div>
//       </Section>
//     </>
//   );
// }


// export default ProductProtfolio;

const products = [
  {
    imgUrl: "/images/home_1/solvira-tablets.jpg",
    title: "Solvira Tablets",
    desc: "A clinically trusted anti-epileptic formulation designed to control seizures and improve neurological stability for long-term patient care.",
    category: "Neurological Sciences",
    badge: "Featured",
  },
  {
    imgUrl: "/images/home_1/solvira-tablets.jpeg",
    title: "Solvira Forte",
    desc: "Advanced stroke-support therapy that enhances recovery, promotes brain cell protection, and supports post-stroke rehabilitation.",
    category: "Cardiovascular Care",
    badge: "New",
  },
  {
    imgUrl: "/images/home_1/riventragold.jpeg",
    title: "Riventra Gold",
    desc: "A powerful analgesic combination offering fast and effective relief from acute and chronic pain conditions.",
    category: "Pain Management",
    badge: "Popular",
  },
  {
    imgUrl: "/images/home_1/riventra-capsulas.jpeg",
    title: "Riventra Capsules",
    desc: "Targeted gastrointestinal therapy that helps reduce acid reflux, protect mucosa, and improve digestive comfort.",
    category: "Gastrointestinal Care",
    badge: "Expanded",
  },
  {
    imgUrl: "/images/home_1/naprodol-tablets.jpeg",
    title: "Naprodol Tablets",
    desc: "Broad-spectrum antibiotic formulation effective against a wide range of bacterial infections with proven safety.",
    category: "Anti-Infective Range",
    badge: "Core",
  },
  {
    imgUrl: "/images/home_1/migrenta-tablets.jpeg",
    title: "Migrenta Tablets",
    desc: "Specialized anti-migraine therapy enriched with antioxidants to reduce frequency and severity of migraine attacks.",
    category: "Wellness Portfolio",
    badge: "Expanded",
  },
  {
    imgUrl: "/images/home_1/cogvince-tablets.jpeg",
    title: "Cogvince Tablets",
    desc: "Cardioprotective formulation that helps regulate cholesterol levels and supports overall heart health.",
    category: "Cardiovascular Care",
    badge: "Core",
  },
  {
    imgUrl: "/images/home_1/citivance-tablets.jpeg",
    title: "Citivance Tablets",
    desc: "Respiratory care solution designed to improve airflow, reduce inflammation, and support lung function.",
    category: "Respiratory Solutions",
    badge: "New",
  },
  {
    imgUrl: "/images/home_1/citivance-500-tablets.jpeg",
    title: "Citivance 500",
    desc: "Metabolic support formula that aids in glycemic control and enhances insulin sensitivity for diabetes care.",
    category: "Metabolic Disorders",
    badge: "Featured",
  },
  {
    imgUrl: "/images/home_1/alzavia-tablets.jpg",
    title: "Alzavia Tablets",
    desc: "Neuro-supportive therapy aimed at improving cognitive function and slowing progression of memory-related disorders.",
    category: "Neurological Sciences",
    badge: "Featured",
  },
];

const categories = ["All", "Neurological Sciences", "Cardiovascular Care", "Pain Management", "Gastrointestinal Care", "Anti-Infective Range", "Wellness Portfolio", "Respiratory Solutions", "Metabolic Disorders"];

// ── Particles ─────────────────────────────────────────────────────────────────
function Particles() {
  const particles = Array.from({ length: 18 }, (_, i) => ({
    id: i,
    left: `${5 + Math.random() * 90}%`,
    delay: `${Math.random() * 15}s`,
    duration: `${10 + Math.random() * 20}s`,
    size: `${1 + Math.random() * 2}px`,
  }));
  return (
    <div className="pp-particles">
      {particles.map((p) => (
        <div
          key={p.id}
          className="pp-particle"
          style={{
            left: p.left,
            animationDelay: p.delay,
            animationDuration: p.duration,
            width: p.size,
            height: p.size,
          }}
        />
      ))}
    </div>
  );
}

// ── Card ──────────────────────────────────────────────────────────────────────
function ProductCard({ item, index, onClick }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); obs.disconnect(); } },
      { threshold: 0.1 }
    );
    if (el) obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`pp-card${visible ? " visible" : ""}`}
      style={{ animationDelay: `${index * 0.1}s` }}
      onClick={() => onClick(item)}
    >
      <div className="pp-card__img-wrap">
        <img src={item.imgUrl} alt={item.title} className="pp-card__img" />
        <div className="pp-card__overlay" />
        <div className="pp-card__view">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        </div>
        <span className="pp-card__badge">{item.badge}</span>
      </div>

      <div className="pp-card__body">
        <h3 className="pp-card__title">{item.title}</h3>
        <p className="pp-card__desc">{item.desc}</p>
        <div className="pp-card__footer">
          <span className="pp-card__category">
            <span className="pp-card__dot" />
            {item.category}
          </span>
          <span className="pp-card__arrow">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="7" y1="17" x2="17" y2="7" />
              <polyline points="7 7 17 7 17 17" />
            </svg>
          </span>
        </div>
      </div>
    </div>
  );
}

// ── Lightbox ─────────────────────────────────────────────────────────────────
function Modal({ item, onClose }) {
  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose]);

  return (
    <div className="pp-modal-bg" onClick={onClose}>
      <div className="pp-modal" onClick={(e) => e.stopPropagation()}>
        <img src={item.imgUrl} alt={item.title} />
        <button className="pp-modal__close" onClick={onClose}>✕</button>
        <div className="pp-modal__info">
          <span className="pp-modal__cat">{item.badge} · {item.category}</span>
          <h2 className="pp-modal__title">{item.title}</h2>
          <p className="pp-modal__desc">{item.desc}</p>
        </div>
      </div>
    </div>
  );
}

// ── Counter animation ─────────────────────────────────────────────────────────
function CountUp({ to, suffix = "" }) {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        let start = 0;
        const step = to / 50;
        const timer = setInterval(() => {
          start += step;
          if (start >= to) { setVal(to); clearInterval(timer); }
          else setVal(Math.floor(start));
        }, 30);
        obs.disconnect();
      }
    }, { threshold: 0.5 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [to]);
  return <span ref={ref} className="pp-stat__num">{val}{suffix}</span>;
}

// ── Main Component ────────────────────────────────────────────────────────────
export default function ProductPortfolio() {
  const [activeFilter, setActiveFilter] = useState("All");
  const [modal, setModal] = useState(null);

  const filtered = activeFilter === "All"
    ? products
    : products.filter((p) => p.category === activeFilter);

  return (
    <>
      <div className="pp-page">
        <Particles />
         <BannerSectionStyle5
         bgUrl="/images/about/banner_bg.jpg"
         imgUrl="/images/about/banner_img.png"
         title="Welcome to Celbion Healthcare"
        subTitle="Our Products"
     />
        {/* ── PRODUCTS ── */}
        <section className="pp-section">
          <div className="pp-container">

            {/* Header */}
            <div className="pp-header">
              <p className="pp-header__tag">Therapeutic Areas</p>
              <h2 className="pp-header__title">Excellence in Every Formulation</h2>
              <p className="pp-header__body">
                Celbion Healthcare delivers meaningful pharmaceutical solutions for patients and healthcare professionals — from epilepsy and stroke care to GERD, antibiotics, and antioxidant therapies.
              </p>
            </div>

            {/* Filters */}
            <div className="pp-filters">
              {categories.map((cat) => (
                <button
                  key={cat}
                  className={`pp-filter-btn${activeFilter === cat ? " active" : ""}`}
                  onClick={() => setActiveFilter(cat)}
                >
                  <span>{cat}</span>
                </button>
              ))}
            </div>

            {/* Grid */}
            <div className="pp-grid">
              {filtered.map((item, idx) => (
                <ProductCard key={item.title + idx} item={item} index={idx} onClick={setModal} />
              ))}
            </div>

            {/* Stats */}
            {/* <div className="pp-stats">
              {[
                { num: 9, suffix: "+", label: "Product Lines" },
                { num: 6, suffix: "", label: "Therapeutic Areas" },
                { num: 15, suffix: "+", label: "Years of Excellence" },
                { num: 50, suffix: "K+", label: "Patients Served" },
              ].map((s) => (
                <div className="pp-stat" key={s.label}>
                  <CountUp to={s.num} suffix={s.suffix} />
                  <span className="pp-stat__label">{s.label}</span>
                </div>
              ))}
            </div> */}

          </div>
        </section>

        {/* ── MODAL ── */}
        {modal && <Modal item={modal} onClose={() => setModal(null)} />}
      </div>
    </>
  );
}
